import TxEntity from "ui/shared/entities/tx/TxEntity";

import chain, { l1Chain } from "configs/app/chain";
import React from "react";
import { useBlockNumber } from "wagmi";
import { Console } from "lib/console";
import { config } from "lib/walletconnect/config";

export const TxEntityReceipt = ({
  isLoading,
  targetTxHash,
  item,
  ...props
}: {
  isLoading: boolean | undefined;
  targetTxHash: string;
  [key: string]: any;
}) => {
  const { data: result } = useBlockNumber({
    chainId: Number(l1Chain.id),
    config: config as any,
    query: {
      enabled: Boolean(l1Chain.id),
      staleTime: 60000,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  });
  Console.log("TxEntityReceipt result", l1Chain.id, result);

  const isBlockTimestampOlderThan30m =
    Boolean(item?.blockTimestamp) &&
    Date.now() - Number(item.blockTimestamp) * 1000 > 30 * 60 * 1000;
  const canShowLink =
    Boolean(Number(item?.blockNumber)) &&
    (Number(result)
      ? Number(item.blockNumber) <= Number(result)
      : isBlockTimestampOlderThan30m);

  return (
    <>
      <TxEntity
        isLoading={isLoading}
        hash={targetTxHash}
        {...props}
        noLink={!canShowLink}
        noCopy={canShowLink}
      />
    </>
  );
};

function arePropsEqual(oldProps: any, newProps: any) {
  return (
    oldProps.targetTxHash === newProps.targetTxHash &&
    oldProps.isLoading === newProps.isLoading &&
    oldProps.blockTimestamp === newProps.blockTimestamp
  );
}

export default React.memo(TxEntityReceipt, arePropsEqual);
